import { Col, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";

import AppLoading from "../../commons/AppLoading";
import EmptyState from "../../commons/EmptyState";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MovementCard from "./components/MovementCard";
import ProductInventoryMovementAPI from "./ProductInventoryMovementAPI";
import ReportHeader from "../report-full/components/ReportHeader";
import { faClockRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router-dom";

const api = new ProductInventoryMovementAPI();

export default function ProductMovementHistoryPage() {
    const { productId } = useParams();

    const [loading, setLoading] = useState(true);
    const [movements, setMovements] = useState([]);

    const load = async () => {
        setLoading(true);
        try {
            const resp = await api.findHistory(productId);
            setMovements(resp.data || []);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        load();
    }, [productId]);

    if (loading) {
        return <AppLoading />;
    }

    return (
        <div className="container">
            <ReportHeader name="Histórico de movimentações" />

            <h5>Histórico de movimentações</h5>

            {movements.length === 0 ? (
                <EmptyState
                    title="Nenhuma movimentação encontrada"
                    description="Este produto ainda não possui movimentações de estoque."
                    icon={<FontAwesomeIcon icon={faClockRotateLeft} />}
                />
            ) : (
                <div className="d-flex flex-column gap-2 mt-3">
                    <Row className="g-3 mt-2">
                        {movements.map((m) => (
                            <Col xs={12} sm={6} md={4} lg={4} key={m.id}>
                                <MovementCard movement={m} onReload={load} />
                            </Col>
                        ))}
                    </Row>
                </div>
            )}
        </div>
    );
}